import React, { useState, useEffect } from 'react';
import { Form } from 'react-final-form';

import { Heading } from '../../components/atoms/Heading';
import { ProgressBar } from '../../components/molecules/ProgressBar';
// import { Image } from '../../components/atoms/Image';
import { MainView } from '../../templates/MainView';

import { StickyButtons } from '../../components/molecules/StickyButtons';
import { ButtonGroup } from '../../components/molecules/ButtonGroup';
import { Button } from '../../components/atoms/Button';
import { useNavigate, useParams } from 'react-router-dom';
import TechniqueForm from '../../components/forms/TechniqueForm';
import { useSelector } from 'react-redux';

function Technique() {
    let { pathway, barrier } = useParams();
    const navigate = useNavigate();
    const [options, setOptions] = useState([]);
    const bcts = useSelector((state) => state.bcts);

    useEffect(() => {
        if (!pathway || !barrier) return;
        let newOpt = [];
        const selectedBarrier = bcts[pathway][barrier];
        if (!selectedBarrier) return;

        if (selectedBarrier.bcts) {
            Object.keys(selectedBarrier.bcts).forEach((key, idx) => {
                const bct = selectedBarrier.bcts[key];

                if (!bct.web_friendly_name) return;
                if (!bct.pivot.web_friendly_text) return;
                newOpt.push({
                    title: bct.web_friendly_name,
                    value: bct.id,
                    label: bct.pivot.web_friendly_text,
                });
            });
            setOptions(newOpt);
        }
    }, [pathway, barrier, bcts]);

    return (
        <MainView>
            <Form
                onSubmit={(values) => navigate(`/pathway-${pathway}/barrier-${barrier}/bct-${values.bct}`)}
                initialValues={{
                    bct: '',
                }}>
                {({ handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="h-auto w-full">
                            <div className="flex flex-col md:flex-col-reverse">
                                <ProgressBar min={0} current={3} max={3} />
                                <div className="bg-primary-200 p-5 md:bg-transparent">
                                    <Heading h3 classes="text-lg md:text-xl">
                                        Habit Hacker
                                    </Heading>
                                </div>
                            </div>
                            <TechniqueForm options={options} classes="w-full object-right-bottom" />
                            <div className="px-6 pb-12 pt-6">
                                <StickyButtons>
                                    <ButtonGroup
                                        mode="pair"
                                        alwaysRow
                                        buttons={[
                                            <Button
                                                label="Back"
                                                mode="secondary"
                                                onClick={() => navigate(-1)}
                                                type="button"
                                                // isDisabled={isFirstStep}
                                            />,
                                            <Button
                                                label="Continue"
                                                mode="primary"
                                                isSubmit
                                                isDisabled={!values.bct}
                                            />,
                                        ]}
                                    />
                                </StickyButtons>
                            </div>
                        </div>
                    </form>
                )}
            </Form>
        </MainView>
    );
}

export default Technique;
